import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Input,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { IMAGE_MAX_SIZES } from '@epicuro-next/ataraxia/image';
import {
  MediaObjectFit,
  MediaObjectPosition,
} from '@epicuro-next/ataraxia/models';
import { ConnectionStatus } from '@epicuro-next/models/users';

export type AvatartSize = 'xs' | 's' | 'm' | 'l' | 'xxl';

/** Avatar component with default image fallback */
@Component({
  selector: 'atx-avatar',
  templateUrl: './avatar.component.html',
  styleUrls: ['./avatar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AvatarComponent implements OnChanges {
  @Input()
  public image?: string;

  @Input()
  public alt: string;

  @Input()
  public size: AvatartSize = 'm';

  @HostBinding('class') get fn() {
    return this.sizeClass();
  }

  @HostBinding('class.available') get available() {
    return this.connectionStatus === ConnectionStatus.AVAILABLE;
  }

  @HostBinding('class.not-available') get notAvailable() {
    return this.connectionStatus === ConnectionStatus.NOTAVAILABLE;
  }

  @HostBinding('class.available-on-call') get availableOnCall() {
    return this.connectionStatus === ConnectionStatus.ONCALL;
  }

  @Input()
  public fullName?: string;

  @Input()
  public editable = false;

  @Input()
  public showLoader = false;

  @Input()
  public connectionStatus?: ConnectionStatus;

  public loadFailed = false;
  public imageMaxSizes = IMAGE_MAX_SIZES;
  public mediaObjectFit = MediaObjectFit;
  public mediaObjectPosition = MediaObjectPosition;

  public ngOnChanges(changes: SimpleChanges) {
    const change = changes.image;
    if (change && !change.isFirstChange()) {
      this.loadFailed = false;
    }
  }

  public initialsFromFullName() {
    if (!this.fullName) return null;
    const parts = this.fullName.split(' ');
    parts.splice(1, parts.length - 2);
    return parts
      .map(([firstLetter]) => firstLetter)
      .join('')
      .toUpperCase();
  }

  /** Image load failed handler */
  public loadFail() {
    this.loadFailed = true;
  }

  public sizeClass() {
    return `avatar-size-${this.size}`;
  }
}
